import React from 'react';

import { HighlightRange, IProductTemplateAttribute, Validation } from 'components/dashboard/product-template-table/utils/interfaces';
import { CellType } from 'utils/enums';
import OutputHighlight from './components/OutputHighlight';
import ValidationOptions from './components/ValidationOptions';

type TimeSpanTypeProps = {
  attribute: IProductTemplateAttribute;
  onBgHighlightsChange: (bgList: HighlightRange[]) => void;
  onValidationChange: (validations: Validation[]) => void;
};

const TimeSpanType: React.FC<TimeSpanTypeProps> = ({
  attribute,
  onBgHighlightsChange,
  onValidationChange,
}) => {
  return (
    <>
      <OutputHighlight
        bgHighlights={attribute.bgHighlightRanges ?? []}
        onAttributeChange={onBgHighlightsChange}
        forTimeSpan
      />
      <ValidationOptions
        cellType={CellType.TIMESPAN}
        validators={attribute.validationOptions?.validators ?? []}
        onValidationChange={onValidationChange}
      />
    </>
  );
};

export default TimeSpanType